<template>
    <div v-redirect-if-no-permission:VIEW_PAYMENTS>
        <loading-component :value="loading_payment"></loading-component>
        <v-card>
            <v-card-title>
                <v-layout>
                    <v-flex xs3 v-if="hasPermission('CHANGE_PAYMENT_STATE')">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn color="primary" v-on="on">General actions</v-btn>
                            </template>
                            <div style="margin: 10px;">
                                <v-btn @click="dialog=true" color="blue">Request All</v-btn>
                                <v-btn @click="stage(null)" color="green">Stage All</v-btn>
                                <v-btn @click="approve_confirm_dialog=true" color="red">Approve All</v-btn>
                            </div>
                        </v-menu>
                    </v-flex>
                    <v-flex xs9 style="padding:8px">
                        <v-select label="Select Status" multiple :items="['PENDING', 'STAGING', 'APPROVED', 'PAID']"
                                  v-model="payment_status"></v-select>
                    </v-flex>
                    <v-flex xs6 style="padding:8px">
                        <choose-date clearable label="Choose weekday" v-model="date_filter"></choose-date>
                    </v-flex>
                    <v-flex xs6 style="padding:8px">
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Search"
                                single-line
                                hide-details
                                @keyup.enter="getData"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-card-title>
            <v-data-table :url="url"
                          :headers="headers"
                          :items="data"
                          :pagination.sync="pagination"
                          :total-items="totalItems"
                          :rows-per-page-items="[5, 10, 15, 25, 100]"
                          :loading="loading">
                <template v-slot:items="props">
                    <tr @click="expandTable(props)">
                        <td class="text-xs-center">{{ props.item.id }}</td>
                        <td class="text-xs-center">
                            <router-link style="text-decoration: none;margin: 0;padding:0" target='_blank'
                                         :to="`/captains/${props.item.captain_id}`">
                                <div style="margin: 0">
                                    <v-tooltip bottom style="margin: 0;padding:0">
                                        <template v-slot:activator="{ on }" style="margin: 0;padding:0">
                                            <v-btn flat color="primary" dark v-on="on" style="margin: 0;padding:0">{{
                                                props.item.captain_name }}
                                            </v-btn>
                                        </template>
                                        <span style="font-size: 20px">{{props.item.username }}</span>
                                    </v-tooltip>
                                </div>
                            </router-link>
                        </td>
                        <td class="text-xs-center" :style="{color: props.item.closing <= 0 ? 'green' : 'red'}">{{
                            props.item.closing }}
                        </td>
                        <td class="text-xs-center" :style="{color: props.item.overall_closing <= 0 ? 'green' : 'red'}">
                            {{
                            props.item.overall_closing }}
                        </td>
                        <td class="text-xs-center"
                            :style="{color: props.item.overall_closing_checker <= 0 ? 'green' : 'red'}">
                            {{
                            props.item.overall_closing_checker }}
                        </td>
                        <td class="text-xs-center" style="color: green">{{ props.item.bonus }}</td>
                        <td class="text-xs-center" style="color: red">{{ props.item.penalties_on }}</td>
                        <td class="text-xs-center">{{ props.item.rides_cnt }}</td>
                        <td class="text-xs-center">{{ props.item.bookings_cnt }}</td>
                        <td class="text-xs-center">{{ props.item.cancelled_bookings_cnt }}</td>
                        <td class="text-xs-center">{{ props.item.status }}</td>
                        <td class="text-xs-center">
                            {{ moment(props.item.created_at).weeksInYear() + moment(props.item.created_at).format('(DD MMM YY)') }}
                        </td>
                        <td class="text-xs-center">
                            <v-btn v-if="hasPermission('CHANGE_PAYMENT_STATE') && (props.item.status === 'PENDING' || props.item.status === 'STAGING')"
                                   color="green" flat @click="openDialog(props.item.id)" icon>
                                <v-icon>check</v-icon>
                            </v-btn>
                            <v-btn v-if="hasPermission('CHANGE_PAYMENT_STATE') && props.item.status === 'PENDING'"
                                   color="blue" flat @click="stage(props.item.id)" icon>
                                <v-icon>publish</v-icon>
                            </v-btn>
                            <v-btn @click="showMore(props.item.id)" icon>
                                <v-icon>info</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </template>
                <template v-slot:expand="props">
                    <v-card flat>
                        <v-container>
                            <v-layout row wrap>
                                <v-flex xs2><b>Approve date:</b></v-flex>
                                <v-flex xs4>{{props.item.approve_datetime}}</v-flex>
                                <v-flex xs2 v-show="props.item.status === 'PAID'"><b>Pay date:</b></v-flex>
                                <v-flex xs4 v-show="props.item.status === 'PAID'">{{props.item.pay_datetime}}</v-flex>
                                <v-flex xs2 v-show="props.item.status === 'PAID'"><b>Account:</b></v-flex>
                                <v-flex xs4 v-show="props.item.status === 'PAID'">{{props.item.account}}</v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="dialog" width="50%">
            <v-card>
                <v-card-title class="headline">Request payment for selected captains</v-card-title>
                <v-card-text>
                    <v-switch v-model="select_date" label="Select Date">

                    </v-switch>
                    <choose-captains-multi v-if="!select_date" style="width:100%"
                                           v-model="captains"
                                           label="Select Captains"></choose-captains-multi>
                    <choose-date v-else v-model="date"></choose-date>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn type="default" flat="flat" @click="dialog = false">Cancel</v-btn>
                    <v-btn color="green" flat="flat" @click="requestPaymentForSelectedCaptains"
                           :disabled="loading_payment">
                        Request
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <confirm-dialog :visible="approve_confirm_dialog" header_class="red" title="Approve payments"
                        @decline="approve_confirm_dialog=false" @approve="approve"
                        text="Are you sure you want to approve all staged payments?"></confirm-dialog>

        <confirm-dialog :visible="approve_one_confirm_dialog" header_class="red" title="Approve payments"
                        @decline="approve_one_confirm_dialog=false"
                        @approve="selected_payment ? approve(selected_payment) : approve_one_confirm_dialog = false"
                        text="Are you sure you want to approve this payment?"></confirm-dialog>
    </div>
</template>

<script>
    import ChooseCaptainsMulti from "@/components/wasilni/input/ChooseCaptainMulti";
    import LoadingComponent from "@/components/LoadingComponent";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import ConfirmDialog from "@/components/wasilni/ConfirmDialog";

    export default {
        name: "Payments",
        title: 'Payments',
        components: {ConfirmDialog, ChooseDate, LoadingComponent, ChooseCaptainsMulti},
        data() {
            return {
                approve_one_confirm_dialog: false,
                approve_confirm_dialog: false,
                model: {
                    actual_paid: {
                        exist: false,
                        amount: null
                    },
                    paid_using: null
                },
                select_date: false,
                date: null,
                date_filter: '',
                valid: false,
                url: 'payment',
                dialog: false,
                captains: [],
                loading_payment: false,
                payment_status: ['PENDING'],
                headers: [
                    {text: 'ID', value: 'id', align: 'center'},
                    {text: 'Captain', value: 'captain_name', align: 'center'},
                    {text: 'Closing', value: 'closing', align: 'center'},
                    {text: 'All', value: 'overall_closing', align: 'center'},
                    {text: 'O.All', value: 'overall_closing_checker', sortable: false, align: 'center'},
                    {text: 'Bonus', value: 'bonus', align: 'center'},
                    {text: 'Penalty', value: 'penalties_on', align: 'center'},
                    {text: '#R', value: 'rides_cnt', align: 'center'},
                    {text: '#B', value: 'bookings_cnt', align: 'center'},
                    {text: '#C', value: 'cancelled_bookings_cnt', align: 'center'},
                    {text: 'Status', value: 'status', align: 'center'},
                    {text: 'Requested At', value: 'created_at', align: 'center'},
                    {text: 'Actions', value: 'Actions', sortable: false, align: 'center'}
                ],
                data: [],
                loading: false,
                search: '',
                items: [],
                totalItems: 0,
                pagination: {
                    rowsPerPage: 10
                },
                selected_payment: null
            };
        },
        watch: {
            pagination: {
                handler() {
                    this.getData();
                },
                deep: true
            },
            payment_status() {
                this.getData();
            },
            date_filter() {
                this.getData();
            },
        },
        mounted() {
            this.getData();
        },
        methods: {
            openDialog(payment_id) {
                this.selected_payment = payment_id;
                this.approve_one_confirm_dialog = true;
            },
            approve(payment_id = null) {
                this.loading_payment = true;
                this.axios.put(`payment/approve`, !payment_id ? {all: 1} : {payment_id})
                    .then((res) => {
                        // this.getData();
                        this.data.forEach(e => e.id === payment_id ? (e.status = 'APPROVED') : null);
                        window.getApp.$emit("SHOW_TOAST", res.data.message, "green");
                        this.approve_confirm_dialog = false;
                        this.approve_one_confirm_dialog = false;
                    })
                    .catch(() => window.getApp.$emit("SHOW_TOAST", 'error', "red"))
                    .finally(() => this.loading_payment = false);
            },
            expandTable(row) {
                if (row.item.status === 'PAID' || row.item.status === 'APPROVED')
                    row.expanded = !row.expanded;
            },
            stage(payment_id = null) {
                let c = confirm("are you sure you want to stage this?");
                if (!c) {
                    return
                }
                this.loading = true;
                this.axios.put('payment/stage' + (payment_id ? `?payment_id=${payment_id}` : ''))
                    .then(() => {
                        this.getData();
                        this.approve_one_confirm_dialog = false;
                        this.approve_confirm_dialog = false;
                    })
                    .catch(err => {
                        try {
                            if (err.response.data.message) {
                                window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
                            } else {
                                window.getApp.$emit("SHOW_TOAST", err.message, "red");
                            }
                        } catch (e) {
                            console.log(err.message, e.message);
                        }
                    }).finally(() => this.loading = false);
            },
            showMore(id) {
                let routeData = this.$router.resolve(`/accounting/captain/payments/${id}`);
                window.open(routeData.href, '_blank');
            },
            requestPaymentForSelectedCaptains() {
                if (!this.select_date && !this.captains.length && this.select_date && !this.date) {
                    window.getApp.$emit('SHOW_TOAST', 'No selected captains or date', 'red');
                    return;
                }
                const formData = new FormData();
                if (this.select_date) {
                    formData.append('date', this.date);
                } else {
                    for (let i = 0; i < this.captains.length; i++) {
                        formData.append('captains[]', this.captains[i]);
                    }
                }
                this.loading_payment = true;
                this.axios.post('payment/request_all', formData)
                    .then(() => {
                        this.captains = [];
                        this.dialog = false;
                        this.getData();
                    })
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading_payment = false);
            },
            getData() {
                this.loading = true;
                const params = new URLSearchParams();
                params.append('page', this.pagination.page);
                params.append("perPage", String(this.pagination.rowsPerPage));
                params.append("sortBy", String(this.pagination.sortBy));
                params.append("descending", String(this.pagination.descending));
                params.append("search", String(this.search));
                params.append("status", String(this.payment_status));
                if (this.date_filter) params.append("weekday", String(this.date_filter));
                this.axios.get(this.url, {params})
                    .then(res => {
                        this.data = res.data.data.data;
                        this.totalItems = res.data.data.total;
                        this.pagination.rowsPerPage = Number(res.data.data.per_page);
                        this.loading = false;
                    }).catch(err => {
                    console.log(err.message);
                    this.loading = false;
                });
            },
        }
    }
</script>

<style scoped>

</style>